import { ModelAnswer } from '@/domain/entities/modelAnswer/modelAnswer'
import { ModelAnswerRepository } from '@/domain/repositories/modelAnswer/modelAnswerRepository'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

export class GetSolutionWithRatingUseCase {
  constructor(private modelAnswerRepository: ModelAnswerRepository) {}

  async getSolutionWithRatingUseCase(
    problemId: string,
    programLanguage: ProgramLanguageType,
    pageIndex: number
  ): Promise<ModelAnswer[]> {
    try {
      const data = await this.modelAnswerRepository.getSolutionWithRating(problemId, programLanguage, pageIndex)
      data.sort((a, b) => b.rating - a.rating)
      return data
    } catch (error) {
      console.error(`Error in GetSolutionWithRatingUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
